import React from 'react';
import ReactDOMClient from 'react-dom/client';
import TagManager from 'react-gtm-module';

import App from './app/app';
import './i18n';
import './sentry/instrument';

const tagManagerArgs = {
  gtmId: 'GTM-NGG29LG',
};

if (typeof window !== 'undefined') {
  TagManager.initialize(tagManagerArgs);
}

const container = document.getElementById('root');

const root = ReactDOMClient.createRoot(container);

root.render(<App />);
